document.addEventListener("alpine:init", () => {
    Alpine.data("timeline", () => ({
        years: null,
        currentYear: null,
        init() {
            this.years = this.$el.querySelectorAll("[data-current-year]");

            const observer = new MutationObserver(() => {
                this.togglePulse();
            });

            observer.observe(document.querySelector(".Timeline__year"), {
                subtree: true,
                childList: true,
            });
        },
        togglePulse() {
            this.$refs.timelineYear.classList.remove("pulse");
            setTimeout(() => {
                this.$refs.timelineYear.classList.add("pulse");
            }, 1);
        },
        onScroll() {
            let relativeTop = window.innerHeight / 2;

            let yearsByDistanceFromTop = {};

            if (this.years.length && relativeTop != false) {
                this.years.forEach((year) => {
                    yearsByDistanceFromTop[
                        year.getBoundingClientRect().top - relativeTop
                    ] = year;
                });

                let closestNegativeTop = Math.max(
                    ...Object.keys(yearsByDistanceFromTop).filter(
                        (top) => top < 0
                    )
                );

                if (
                    closestNegativeTop >= 0 ||
                    [Infinity, NaN, -Infinity].includes(closestNegativeTop)
                )
                    return (this.visibleHeadingId = null);

                this.currentYear =
                    yearsByDistanceFromTop[
                        closestNegativeTop
                    ].dataset.currentYear;
            }
        },
    }));
});
